/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Step_WelcomeInputs */

const en_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome`)
};

const de_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen`)
};

const fr_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue`)
};

const es_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido`)
};

const it_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto`)
};

const nl_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welkom`)
};

const pl_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witamy`)
};

const fi_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tervetuloa`)
};

const da_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velkommen`)
};

const sv_onboarding_step_welcome = /** @type {(inputs: Onboarding_Step_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välkommen`)
};

/**
* | output |
* | --- |
* | "Welcome" |
*
* @param {Onboarding_Step_WelcomeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_step_welcome = /** @type {((inputs?: Onboarding_Step_WelcomeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Step_WelcomeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_step_welcome(inputs)
	if (locale === "fr") return fr_onboarding_step_welcome(inputs)
	if (locale === "es") return es_onboarding_step_welcome(inputs)
	if (locale === "it") return it_onboarding_step_welcome(inputs)
	if (locale === "nl") return nl_onboarding_step_welcome(inputs)
	if (locale === "pl") return pl_onboarding_step_welcome(inputs)
	if (locale === "fi") return fi_onboarding_step_welcome(inputs)
	if (locale === "da") return da_onboarding_step_welcome(inputs)
	if (locale === "sv") return sv_onboarding_step_welcome(inputs)
	return en_onboarding_step_welcome(inputs)
});